var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-feedback-section"},[(_vm.userIsInterpreter)?_c('personal-feedback-supplier-side',{on:{"submitsection":_vm.save}}):_c('personal-feedback-buyer-side',{on:{"submitsection":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }